import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PoliticaCookiesPage() {
  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Política de Cookies - VaciadoPro Barcelona';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Política de cookies de VaciadoPro Barcelona. Información sobre el uso de cookies y tecnologías similares en nuestro sitio web.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'política cookies, uso cookies, tecnologías web, VaciadoPro Barcelona');
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/politica-cookies`);
    }

    // No indexar páginas legales
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex, nofollow');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-green-600 to-green-700 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Política de Cookies
              </h1>
              <p className="text-xl text-green-100">
                Información sobre el uso de cookies en nuestro sitio web. 
                Conoce más sobre 
                <a href="/empresa" className="text-green-200 hover:text-white font-medium ml-1 mr-1">
                  nuestra empresa
                </a>
                y 
                <a href="/servicios" className="text-green-200 hover:text-white font-medium ml-1">
                  nuestros servicios
                </a>.
              </p>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto prose prose-lg">
              <div className="bg-white rounded-lg shadow-lg p-8">
                
                <h2 className="text-2xl font-bold text-gray-900 mb-6">¿Qué son las cookies?</h2>
                <p className="text-gray-700 mb-6">
                  Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. 
                  Estas cookies nos ayudan a mejorar su experiencia de navegación y a proporcionar servicios más personalizados.
                  Para más información sobre nuestros servicios, visite 
                  <a href="/servicios" className="text-green-600 hover:text-green-700 font-medium ml-1">
                    nuestra página de servicios
                  </a>.
                </p>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Tipos de cookies que utilizamos</h3>
                
                <div className="space-y-6">
                  <div className="border-l-4 border-green-500 pl-6">
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Cookies técnicas (necesarias)</h4>
                    <p className="text-gray-700">
                      Son esenciales para el funcionamiento del sitio web. Permiten la navegación y el uso de diferentes 
                      opciones o servicios que existen en él, como controlar el tráfico y la comunicación de datos.
                    </p>
                  </div>

                  <div className="border-l-4 border-blue-500 pl-6">
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Cookies de preferencias</h4>
                    <p className="text-gray-700">
                      Permiten recordar información para que el usuario acceda al servicio con determinadas características 
                      que pueden diferenciar su experiencia de la de otros usuarios, como el idioma o la región.
                    </p>
                  </div>

                  <div className="border-l-4 border-yellow-500 pl-6">
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Cookies analíticas</h4>
                    <p className="text-gray-700">
                      Permiten el seguimiento y análisis del comportamiento de los usuarios en el sitio web. 
                      La información recogida se utiliza para la medición de la actividad y para la elaboración 
                      de perfiles de navegación con el fin de introducir mejoras.
                    </p>
                  </div>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4 mt-8">Cookies específicas que utilizamos</h3>
                
                <div className="overflow-x-auto">
                  <table className="min-w-full bg-white border border-gray-200 rounded-lg">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cookie</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Propósito</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Duración</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      <tr>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">cookieConsent</td>
                        <td className="px-6 py-4 text-sm text-gray-700">Recordar la preferencia del usuario sobre cookies</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">1 año</td>
                      </tr>
                      <tr className="bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">sessionId</td>
                        <td className="px-6 py-4 text-sm text-gray-700">Mantener la sesión del usuario activa</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Sesión</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4 mt-8">Gestión de cookies</h3>
                <p className="text-gray-700 mb-4">
                  Puede configurar su navegador para aceptar o rechazar automáticamente todas las cookies, 
                  o para recibir un aviso en pantalla de la recepción de cada cookie y decidir en ese momento 
                  su implantación o no en su disco duro.
                </p>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-6">
                  <div className="flex items-start">
                    <i className="ri-information-line text-yellow-600 text-xl mr-3 mt-1"></i>
                    <div>
                      <h4 className="text-lg font-semibold text-yellow-800 mb-2">Importante</h4>
                      <p className="text-yellow-700">
                        Si decide deshabilitar las cookies, es posible que algunas funcionalidades del sitio web 
                        no funcionen correctamente o que su experiencia de navegación se vea afectada.
                      </p>
                    </div>
                  </div>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Configuración en navegadores principales</h3>
                
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-gray-50 rounded-lg p-6">
                    <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                      <i className="ri-chrome-line text-xl mr-2"></i>
                      Google Chrome
                    </h4>
                    <p className="text-sm text-gray-700">
                      Configuración → Privacidad y seguridad → Cookies y otros datos de sitios
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 rounded-lg p-6">
                    <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                      <i className="ri-firefox-line text-xl mr-2"></i>
                      Mozilla Firefox
                    </h4>
                    <p className="text-sm text-gray-700">
                      Opciones → Privacidad y seguridad → Cookies y datos del sitio
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 rounded-lg p-6">
                    <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                      <i className="ri-safari-line text-xl mr-2"></i>
                      Safari
                    </h4>
                    <p className="text-sm text-gray-700">
                      Preferencias → Privacidad → Gestionar datos de sitios web
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 rounded-lg p-6">
                    <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                      <i className="ri-edge-line text-xl mr-2"></i>
                      Microsoft Edge
                    </h4>
                    <p className="text-sm text-gray-700">
                      Configuración → Cookies y permisos de sitio → Cookies y datos almacenados
                    </p>
                  </div>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4 mt-8">Contacto</h3>
                <p className="text-gray-700 mb-4">
                  Si tiene alguna pregunta sobre nuestra política de cookies, puede contactarnos:
                </p>
                
                <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                  <div className="space-y-2">
                    <p className="flex items-center text-gray-700">
                      <i className="ri-mail-line text-green-600 mr-3"></i>
                      <strong>Email:</strong> info@vaciadopro.es
                    </p>
                    <p className="flex items-center text-gray-700">
                      <i className="ri-phone-line text-green-600 mr-3"></i>
                      <strong>Teléfono:</strong> +34 690 22 09 44
                    </p>
                    <p className="flex items-center text-gray-700">
                      <i className="ri-map-pin-line text-green-600 mr-3"></i>
                      <strong>Dirección:</strong> Barcelona, España
                    </p>
                    <p className="text-gray-700 mt-2">
                      También puede usar nuestro 
                      <a href="/contacto" className="text-green-600 hover:text-green-700 font-medium ml-1">
                        formulario de contacto
                      </a> 
                      o conocer más sobre 
                      <a href="/empresa" className="text-green-600 hover:text-green-700 font-medium ml-1">
                        nuestra empresa
                      </a>.
                    </p>
                  </div>
                </div>

                <div className="mt-8 pt-6 border-t border-gray-200">
                  <p className="text-sm text-gray-500">
                    <strong>Última actualización:</strong> Diciembre 2024
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
